import AbstractStorage from './AbstractStorage';
import {getSafeStorage} from './safeStorage';

const storage = () => getSafeStorage('localStorage');

class LocalStorage extends AbstractStorage {
  static get<T = string>(key: string): T | null {
    const raw = storage().getItem(key);
    if (raw === null || raw === undefined) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return raw as unknown as T;
    }
  }

  static set<T>(key: string, value: T): void {
    if (value) {
      storage().setItem(key, JSON.stringify(value));
    }
  }

  static remove(key: string): void {
    storage().removeItem(key);
  }

  static clear(): void {
    storage().clear();
  }

  static getKeys(): string[] {
    return storage().keys();
  }
}

export {LocalStorage};
